import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useRecoilState, useSetRecoilState } from "recoil";
import { cashModalState, twoButtonModalState } from "../../utils/atom";
import ModalWrapper from "./ModalWrapper";
import Button from "../elements/Button";
import Input from "../elements/Input";
import { Dot, toNumber } from "../../utils/CommonFunction";
import { api } from "../../utils/api";

import { ReactComponent as Remove } from "../../assets/icons/delete-icon.svg";

const CashModal = () => {
  const [modal, setModal] = useRecoilState(cashModalState);
  const setTwoButtonModal = useSetRecoilState(twoButtonModalState);

  const [price, setPrice] = useState<string>("");

  const handleClose = () => {
    setPrice("");
    setModal(null);
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    if (modal?.type === "complete") {
      formData.append("cash", toNumber(price));
    } else {
      formData.append("type", modal?.type === "plus" ? "1" : "2");
      formData.append("cash", toNumber(price));
    }

    const {
      data: { success, alert, data: data2 },
    } = await api.post(
      modal?.type === "complete" ? "/cash/complete" : "/cash/modify",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (success) {
      if (modal?.type === "complete") {
        setTwoButtonModal({
          title: "정산 마감 완료",
          text: "정산 마감 처리가 완료되었습니다.<br/>서비스를 종료하시겠어요?",
          cancleText: "서비스 종료",
          confirmText: "취소",
          onClose: () => {},
        });
      }

      modal?.mutate && modal?.mutate();
      setPrice("");
      setModal(null);
    } else {
      window.alert(alert);
      setPrice("");
    }
  };

  const handleClick = (value: number) => {
    setPrice(String(Number(toNumber(price + value))));
  };

  const handleRemove = () => {
    if (price.length > 0) setPrice(price.slice(0, price.length - 1));
  };

  if (modal === null) return null;

  return (
    <ModalWrapper onClose={handleClose}>
      <Wrapper>
        <Title>
          {modal?.type === "plus"
            ? "입금하기"
            : modal?.type === "minus"
            ? "출금하기"
            : "정산 마감"}
        </Title>
        <Input
          className="light"
          placeholder="금액 입력"
          value={Dot(Number(price))}
          onChange={(e) => {
            let value = toNumber(e.target.value);
            setPrice(Dot(Number(value)));
          }}
        />
        <DialArea>
          <Dial onClick={() => handleClick(1)}>1</Dial>
          <Dial onClick={() => handleClick(2)}>2</Dial>
          <Dial onClick={() => handleClick(3)}>3</Dial>
          <Dial onClick={() => handleClick(4)}>4</Dial>
          <Dial onClick={() => handleClick(5)}>5</Dial>
          <Dial onClick={() => handleClick(6)}>6</Dial>
          <Dial onClick={() => handleClick(7)}>7</Dial>
          <Dial onClick={() => handleClick(8)}>8</Dial>
          <Dial onClick={() => handleClick(9)}>9</Dial>
          <Dial onClick={handleRemove}>
            <Remove />
          </Dial>
          <Dial onClick={() => handleClick(0)}>0</Dial>
        </DialArea>
        <ButtonArea>
          <Button styleType="line" onClick={handleClose}>
            취소
          </Button>
          <Button disabled={price === ""} onClick={handleSubmit}>
            {modal?.type === "plus"
              ? "입금 처리"
              : modal?.type === "minus"
              ? "출금 처리"
              : "정산 처리"}
          </Button>
        </ButtonArea>
      </Wrapper>
    </ModalWrapper>
  );
};

export default CashModal;

const ButtonArea = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > button {
    max-width: calc(50% - 5px);
  }
`;

const Dial = styled.div`
  width: calc(33.33% - 13.33px);
  height: 50px;
  margin-right: 20px;
  border-radius: 10px;
  background: rgba(34, 34, 37, 0.4);
  font-size: 26px;
  font-weight: 700;
  line-height: 36px;
  letter-spacing: 0.06em;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  & > svg {
    width: 32px;
    height: 24px;
  }

  &:nth-of-type(3n) {
    margin-right: 0;
  }

  &:nth-of-type(n + 4) {
    margin-top: 4px;
  }
`;

const DialArea = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 16px 0 30px;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  line-height: 21px;
  color: white;
  margin-bottom: 18px;
`;

const Wrapper = styled.div`
  min-width: 260px;
  width: 260px;
  padding: 22px;
  background: ${(props) => props.theme.color.gray3};
  border-radius: 18px;
  border: solid 1px ${(props) => props.theme.color.gray4};
`;
